// extracted by mini-css-extract-plugin
module.exports = {"header":"header-2eGus","close":"close-1V8MD","terms":"terms-tyTpO"};